import queryString from 'query-string';
import {getUrlParts, isEmpty, stripToRoot} from '../utils';

export default class ListingUrlParser {
    parse(url) {
        const baseUrl = stripToRoot(url);
        const [, params] = getUrlParts(url);
        let searchRequest = {baseUrl};

        if (!isEmpty(params)) {
            const queryParams = queryString.parseUrl(params).query;

            searchRequest = {
                ...searchRequest,
                ...queryParams
            };
        }

        return searchRequest;
    }
}
